export default {"src":"/_next/static/media/grid-on.72b9c8b7.svg","height":17,"width":17};